export default {
  //* loadSentEmails ---------------------------------------------------------------------------------------------------------------

  async loadSentEmails({ rootGetters }, dati) {
    // load contacts from backend
    /*
			! ATTENTION:
			commit to store not added !
		*/
    var thread = dati.thread;
    delete dati.idCliente;
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok; // composition of the token
    const response = await fetch(
      base_address + "/tracciaMail/getLazy/" + thread,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: tok,
        },
        body: JSON.stringify(dati),
        mode: "cors", // no-cors, *cors, same-origin
      }
    ).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      // console.log("🚀 ~ file: actions.js:33 ~ loadSentEmails ~ resp_json:", resp_json)
      return resp_json;
    }
    return {};
  },

  //* loadInboxMails ---------------------------------------------------------------------------------------------------------------

  async loadInboxMails({ rootGetters }, dati) {
    // load contacts from backend
    /*
			! ATTENTION:
			commit to store not added !
		*/
    // console.log(dati)
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok; // composition of the token
    //! request the access token
    await fetch(base_address + "/gmailCrm/getAccessToken", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      body: JSON.stringify(dati),
      mode: "cors", // no-cors, *cors, same-origin
    }).catch((e) => console.log(e));
    const response = await fetch(base_address + "/gmail/getEmails", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      body: JSON.stringify(dati),
      mode: "cors", // no-cors, *cors, same-origin
    }).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      return resp_json;
    }
    return {};
  },

  //* addTracciaMail ---------------------------------------------------------------------------------------------------------------

  async addTracciaMail({ rootGetters }, payload) {
    // @payload needs the contact infos needed
    /*
			! ATTENTION:
			commit to store not added !
		*/
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    await fetch(base_address + "/tracciaMail/addMail", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(payload),
    }).then((response) => {
      const resp = response.json();
      if (response.ok) {
        ret_val = resp; // means ok, all right (http protocol)
      }
    });
    return ret_val;
  },

  //* getEmailCV ---------------------------------------------------------------------------------------------------------------

  async getEmailCV({ rootGetters }, payload) {
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    await fetch(base_address + "/getMailCV", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(payload),
    }).then((response) => {
      const resp = response.json();
      if (response.ok) {
        ret_val = resp; // means ok, all right (http protocol)
      }
    });
    return ret_val;
  },

  //* addAllegato ---------------------------------------------------------------------------------------------------------------

  async addAllegato({ rootGetters }, payload) {
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    await fetch(base_address + "/allegati/addAllegato", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(payload),
    }).then((response) => {
      const resp = response.json();
      if (response.ok) {
        ret_val = resp; // means ok, all right (http protocol)
      }
    });
    return ret_val;
  },

  //* getAllegati ---------------------------------------------------------------------------------------------------------------

  async getAllegati({ rootGetters }, id) {
    var ret_val = [],
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    await fetch(base_address + "/allegati/getAllegati/" + id, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
    }).then(async (response) => {
      const resp = await response.json();
      if (response.ok) {
        ret_val = resp; // means ok, all right (http protocol)
      }
    });
    return ret_val;
  },

  //* annullaNewsletter ---------------------------------------------------------------------------------------------------------------

  async checkNewsletter({ rootGetters }, data) {
    // load quotes from backend
    var base_address = rootGetters["settings/getBaseAddress"];
    var response = await fetch(base_address + "/checkNewsletter", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(data),
    }).catch((e) => console.log(e));
    response = await response.json();
    // console.log(response);
    return response;
  },

  //* annullaNewsletter ---------------------------------------------------------------------------------------------------------------

  async annullaNewsletter({ rootGetters }, data) {
    // load quotes from backend
    var base_address = rootGetters["settings/getBaseAddress"];
    var response = await fetch(base_address + "/annullaNewsletter", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(data),
    }).catch((e) => console.log(e));
    response = await response.json();
    // console.log(response);
    return response;
  },

  //* iscriviNewsletter ---------------------------------------------------------------------------------------------------------------

  async iscriviNewsletter({ rootGetters }, data) {
    // load quotes from backend
    var base_address = rootGetters["settings/getBaseAddress"];
    var response = await fetch(base_address + "/iscriviNewsletter", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(data),
    }).catch((e) => console.log(e));
    response = await response.json();
    // console.log(response);
    return response;
  },

  //* deleteAllegato ---------------------------------------------------------------------------------------------------------------

  async deleteAllegato({ rootGetters }, id) {
    var ret_val = [],
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    await fetch(base_address + "/allegati/deleteAllegato/" + id, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
    }).then(async (response) => {
      const resp = await response.json();
      if (response.ok) {
        ret_val = resp; // means ok, all right (http protocol)
      }
    });
    return ret_val;
  },

  //* GmailInfos ---------------------------------------------------------------------------------------------------------------

  async GmailInfos({ rootGetters }) {
    var ret_val = [],
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    //! request the access token
    await fetch(base_address + "/gmailCrm/getAccessToken", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      body: JSON.stringify({}),
      mode: "cors", // no-cors, *cors, same-origin
    }).catch((e) => console.log(e));
    await fetch(base_address + "/gmail/getMyEmail", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
    }).then(async (response) => {
      const resp = await response.json();
      if (response.ok) {
        ret_val = resp; // means ok, all right (http protocol)
      }
    });
    return ret_val;
  },

  //* readmail ---------------------------------------------------------------------------------------------------------------

  async readmail({ rootGetters }, id) {
    console.log(id);
    var tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    //! request the access token
    await fetch(base_address + "/gmailCrm/getAccessToken", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      body: JSON.stringify({}),
      mode: "cors", // no-cors, *cors, same-origin
    }).catch((e) => console.log(e));

    //! make it read
    await fetch(base_address + "/gmail/makeReadEmail/" + id, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      body: JSON.stringify({}),
      mode: "cors", // no-cors, *cors, same-origin
    }).catch((e) => console.log(e));

    return 200;
  },

  //* emailNuoveArrivate ---------------------------------------------------------------------------------------------------------------

  async newMails({ rootGetters }) {
    var ret_val = [],
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    //! request the access token
    await fetch(base_address + "/gmailCrm/getAccessToken", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      body: JSON.stringify({}),
      mode: "cors", // no-cors, *cors, same-origin
    }).catch((e) => console.log(e));
    //! call api
    const response = await fetch(base_address + "/gmail/newMails", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      body: JSON.stringify({}),
      mode: "cors", // no-cors, *cors, same-origin
    }).catch((e) => console.log(e));

    if (response.ok) {
      const resp_json = await response.json();
      // console.log("🚀 ~ file: actions.js:386 ~ newMails ~ resp_json:", resp_json)
      ret_val = resp_json.messagesTotal;
    }

    return ret_val;
  },
};
